export default __webpack_public_path__ + "static/media/cliente_becado.1d79ab03.svg";